export enum EventName {
  Error = "error",
  AnswerSubmitted = "answerSubmitted",
  Click = "click",
}
